<template>
  <div class="page">
    <div class="container">
      <div class="tabs">
        <el-tabs v-model="testTabs.value" @tab-click="handleClickTabs" center>
          <el-tab-pane
            v-for="item in testTabs.list"
            :key="item.id"
            :label="item.title"
            :name="item.id"
          >
            <!-- 入学测试 -->
            <template>
              <el-form :inline="true" :model="formQuery" label-width="100px">
                <el-form-item label="所属科目">
                  <el-select
                    v-model="formQuery.subject_id"
                    placeholder="请选择科目"
                    size="mini"
                    clearable
                    @change="methodSearch"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      v-for="(item, index) of subjectList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="题库名称">
                  <el-input
                    v-model="formQuery.name"
                    placeholder="请输入名称"
                    size="mini"
                    @keyup.enter.native="methodSearch"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item style="padding-left: 15px;">
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    size="mini"
                    @click="methodSearch"
                    >查询</el-button
                  >
                </el-form-item>
              </el-form>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          style="width: 100%;"
          :header-row-style="{
            'border-radius': '5px',
            overflow: 'hidden',
          }"
          :header-cell-style="{
            background: 'rgb(245, 247, 250)',
            color: 'rgb(96, 98, 102)',
          }"
        >
          <el-table-column type="index" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 + (currentPage - 1) * pageSize }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :prop="columnItem.value"
            :label="columnItem.label"
            v-for="columnItem in tableTitle"
            :key="columnItem.value"
            :align="columnItem.align"
            :width="columnItem.width"
          >
          </el-table-column>
          <el-table-column
            type="operation"
            label="操作"
            align="center"
            width="240"
          >
            <template v-slot="scope">
              <div>
                <el-button
                  @click="CreatePractice(scope.row)"
                  type="text"
                  size="mini"
                  class="wg-table-operation"
                >
                  布置练习
                </el-button>
                <el-button
                  @click="CreateExam(scope.row)"
                  type="text"
                  size="mini"
                  class="wg-table-operation"
                >
                  发起考试
                </el-button>
                <el-button
                  @click="methodQuestionBankPreview(scope.row)"
                  type="text"
                  size="mini"
                  class="wg-table-operation"
                  >题库预览</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api_getSchoolQuestionBankList } from '@/api/competitionCenter'
import { getZoneSchoolSubjectList } from '@/api/community'
// 阶段测评
export default {
  //   data() {
  //     return {
  //       testTabs: {
  //         value: '1',
  //         list: [
  //           { label: '入学测试', value: '1' },
  //           { label: '期中测试', value: '2' },
  //           { label: '期末师训', value: '3' },
  //         ],
  //       },
  //     }
  //   },
  name: 'formativeTest',
  props: ['sourceList'],
  data: () => ({
    testTabs: {
      value: '',
      list: [],
    },
    formQuery: {
      subject_id: '',
      name: '',
    },
    subjectList: [],
    tableTitle: [
      { label: '科目', value: 'subjectName', align: 'left', width: '80' },
      { label: '题库名称', value: 'title', align: 'left', width: '250' },
      { label: '来源', value: '_source_id', align: 'left', width: '150' },
      { label: '简介', value: 'content', align: 'left' },
      { label: '题数', value: 'question_num', align: 'center', width: '100' },
    ],
    tableData: [],
    currentPage: 1,
    pageSize: 10,
    total: 1,
  }),
  created() {
    this.testTabs = {
      value: this.sourceList[0].id,
      list: this.sourceList,
    }
    this.methodSearch()
    this.getZoneSchoolSubjectList()
    console.log('经历几次')
  },
  methods: {
    handleClickTabs() {
      this.formQuery = {
        subject_id: '',
        name: '',
      }
      this.currentPage = 1
      this.pageSize = 10
      this.methodSearch()
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.methodSearch()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.methodSearch()
    },
    methodSearch() {
      this.getSchoolQuestionBankList()
    },
    async getZoneSchoolSubjectList() {
      const res = await getZoneSchoolSubjectList()
      if (res) {
        this.subjectList = res.subjectList
      }
    },
    async getSchoolQuestionBankList() {
      const res = await api_getSchoolQuestionBankList({
        source_id: this.testTabs.value,
        title: this.formQuery.name,
        subject_id: this.formQuery.subject_id,
        page_no: this.currentPage,
        page_size: this.pageSize,
      })
      console.log(res)
      if (res) {
        res.questionBankList.forEach((elem) => {
          elem._source_id = elem.sourceInfo.title
        })
        this.tableData = res.questionBankList
        this.currentPage = res.page_no
        this.pageSize = res.page_size
        this.total = res.total
      }
    },
    methodQuestionBankPreview(row) {
      console.log('试题管理')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-PlatformQuestionlist1',
        query: {
          id: row.id,
          title: row.title,
          subject_id: row.subject_id,
        },
      })
    },
    CreatePractice(item) {
      console.log('创建练习', item)
      this.$router.push({
        name: 'CommonExam-CreatePractice',
        query: {
          id: item.id, // 题库ID
          // subject_id: item.subject_id, // 科目
          // bank_type: '1', // 类型 ''全部 '1'平台题库 '2'校区题库
          // source_id: item.source_id, // 题库来源
          // bank_name: item.title, // 题库名称
          papername: item.title,
          subject_id: item.subject_id, // 科目ID
        },
      })
    },
    CreateExam(item) {
      console.log('创建考试', item)
      this.$router.push({
        name: 'CommonExam-CreateExam',
        query: {
          papername: item.title, // 试卷名称+当前时间
          id: item.id, // 题库ID
          subject_id: item.subject_id, // 科目ID
          source_id: item.source_id, // 来源ID
        },
      })
    },
  },
}
</script>
<style scoped lang="scss">
.page {
  .container {
    max-width: 1680px;
    margin: auto;
    .tabs {
      margin-bottom: 20px;
      border-radius: 5px;
      background-color: #fff;
      /deep/ .el-tabs {
        .el-tabs__header {
          position: initial;
          .el-tabs__nav-wrap {
            width: initial;
            transform: none;
            left: initial;
            padding-left: 28px;
            .el-tabs__nav-scroll {
              display: block;
              .el-tabs__nav {
                .el-tabs__item {
                  font-size: 16px;
                }
              }
            }
          }
        }
        .el-tabs__content {
          .el-form {
            padding-top: 6px;
            text-align: right;
            .el-form-item {
              margin-bottom: 8px;
            }
          }
        }
      }
    }
    .table {
      padding: 30px 40px;
      background-color: #fff;
      border-radius: 5px;
      .pagination {
        padding-top: 20px;
        text-align: right;
      }
    }
  }
}
</style>
